import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#DB5430",
      light: "rgba(219, 84, 84, 0.4)",
      dark: "#fff",
    },
    secondary: {
      main: "#222222",
      light: "#878680",
    },
  },
  typography: {
    fontFamily: "Poppins, Roboto, Arial, sans-serif",
    h1: {
      fontSize: "2.5rem",
      fontWeight: 700,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 700,
    },
    h7: {
      fontWeight: "600",
      textTransform: "uppercase",
    },
    body1: {
      lineHeight: "1.7rem"
    }
  },
});

export default theme;
